import { auditReports } from '@mi-front/api-clients';
import { useRouter } from '@mi-front/core';
import { QueryView } from '@mi-front/ui';
import { useParams } from 'react-router-dom';
import { AodRuleViewScreenP } from './AodRuleViewScreenP';

export function AodRuleViewPage() {
  const { id } = useParams<{ id: string }>();
  const { match } = useRouter();
  const ruleQuery = auditReports.useGetOneBaseAodRulesControllerAodRule(id);

  return (
    <QueryView query={ruleQuery}>
      {(rule) => <AodRuleViewScreenP path={match.path} rule={rule} />}
    </QueryView>
  );
}
